<template>
  <v-dialog v-model="show" :max-width="400" persistent>
    <v-card>
      <v-card-title :style="$store.getters['membership'].style" class="white--text">
        New portal
        <v-spacer></v-spacer>
        <v-btn dark icon @click="show=false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <v-row>
          <v-col cols="12" v-if="template">
            <v-text-field label="From Template" hide-details :value="template.name" readonly></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              label="My Portal Name"
              :rules="[this.$helpers.rules.min_short]"
              v-model="new_portal.name"
              v-on:keyup.enter="createPortal"
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions class="grey lighten-3">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="createPortal"
          :disabled="!(new_portal.name && new_portal.name.length>3)"
        >Create</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "NewPortal",
  created() {
    this.$eventBus.$on(
      "new-portal",
      function(template) {
        this.tryCreate(template);
      }.bind(this)
    );
  },
  data() {
    return {
      show: false,
      template: null,
      new_portal: {
        name: ""
      }
    };
  },
  methods: {
    async tryCreate(template) {
      //See if subscription is valid.
      if (!this.$store.getters["isLoggedIn"]) {
        return this.$router.push("/login");
      }
      if (this.$store.getters["trial_ended"]) {
        return this.$eventBus.$emit("trial-ended");
      }
      if (this.$store.getters["isTrial"]) {
        if (this.$store.state.portal_count >= this.$store.getters["limit"]) {
          return this.$router.push("/subscription");
        }
      }
      //Maybe here we can first check if upgrade is required instead of when they click "Create" for createPortal()
      if (template) {
        this.template = template;
      } else {
        this.template = null;
      }
      this.show = true;
    },
    async reachedLimit() {
      //Before asking for upgrade make sure we have an available option.
      //Otherwise display a different popup
      if (this.$store.getters["upgrade"]) {
        return false;
      } else {
        this.$eventBus.$emit("limit-reached");
        return true;
      }
    },
    async requiresUpgrade() {
      //See if user has to upgrade
      if (this.$store.state.portal_count >= this.$store.getters["limit"]) {
        if (this.$store.getters["upgrade"]) {
          this.$eventBus.$emit("upgrade-dialog");
        } else {
          this.$eventBus.$emit("limit-reached");
        }
        return true;
      } else {
        return false;
      }
    },
    async createPortal() {
      if (!this.new_portal.name) {
        return;
      }
      if (this.new_portal.name.length < 4) {
        return;
      }
      let upgrade_required = await this.requiresUpgrade();
      if (upgrade_required) {
        return;
      }

      try {
        let portal = await this.$api.post(`/user/portals`, {
          name: this.new_portal.name,
          template_id: this.template ? this.template.id : null
        });
        this.new_portal.name = "";
        this.$store.dispatch("countPortals");
        this.$eventBus.$emit("new-portal-created");
        this.show = false;
        //console.log("new portal", portal.id);
        this.$router.push(`/portals/${portal.id}`);
      } catch (ex) {
        this.show = false;
        alert(ex.error);
      }
    }
  }
};
</script>

<style>
</style>